'use client';

import { Container } from '@vs-shop/ui/container';
import { useState } from 'react';

import HomepageProductsListing from './HomepageProductsListing';
import HomepageTaxonNavigation from '../../../server/page/homepage/HomepageTaxonNavigation';

import type { HomepageTaxon } from '../../../../effect/schema/openapi/backend';

type Props = {
  taxons: readonly HomepageTaxon[];
};

export default function HomepageProductsWrapper({ taxons }: Props) {
  const [selectedTaxon, setSelectedTaxon] = useState<HomepageTaxon | null>(taxons[0] ?? null);

  const handleTaxonSelect = (taxon: HomepageTaxon) => {
    setSelectedTaxon(taxon);
  };

  return (
    <div className="flex flex-col gap-10" data-slot="homepage-products-wrapper">
      <div className="flex flex-col">
        <Container classNameWrapper="flex justify-center items-center">
          <HomepageTaxonNavigation
            taxons={taxons}
            selectedTaxon={selectedTaxon}
            onSelectTaxon={handleTaxonSelect}
          />
        </Container>

        <div className="h-[1px] w-full bg-background-intense-more" />
      </div>

      {selectedTaxon && <HomepageProductsListing taxonCode={selectedTaxon.code} />}
    </div>
  );
}
